// extracted by mini-css-extract-plugin
export default {"container":"bed-allocation-dashboard_container__EtRHf","min-width":"bed-allocation-dashboard_min-width__bm0nt"};